import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

export default defineNuxtPlugin(() => {
  // when app is created in browser, restore SSR state from nuxt payload
  if (import.meta.client) {
    dayjs.extend(localizedFormat);
    dayjs.extend(advancedFormat);
    dayjs.extend(utc);
    dayjs.extend(timezone);
    dayjs.extend(isSameOrBefore);
    dayjs.tz.setDefault(dayjs.tz.guess());
    dayjs().format('L LT');
    dayjs.extend(customParseFormat);
  }
});
